import {
  Alert,
  Image,
  ImageBackground,
  NativeEventSubscription,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppIcons } from "../../assets/images";
import FastImage from "react-native-fast-image";
import { AppTheme } from "../../utils/theme";
import { bannerAdKey, piseList, playerOptions } from "../../utils/contants";
import LinearGradient from "react-native-linear-gradient";
import Spacer from "../../components/global/Spacer";
import {
  StackActions,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { PlayerColor } from "../../redux/ludoSlice";
import { ROUTE_NAME } from "../../utils/routes";
// Removed SoundPlayer import (handled in RootRoute)
import { useAppSelector } from "../../redux/storeHook"; // Added dispatch
import { userAction } from "../../redux/reducers/user";
import {
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";

const SelectPlayersTablet = () => {
  const route = useRoute();
  const { mode } = route.params as any;
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const [selectedOption, setSelectedOption] = useState<number>(1);
  const [selectedColor, setSelectedColor] = useState<number>(1);

  const bannerRef = useRef<BannerAd>(null);

  useForeground(() => {
    if (Platform.OS === "ios") {
      bannerRef.current?.load();
    }
  });

  const selectedOptions = (id: number) => {
    userAction.setTouchSound(true); // Trigger touch sound on selection
    setSelectedOption(id);
  };

  const selectedColors = (id: number) => {
    userAction.setTouchSound(true); // Trigger touch sound on color selection
    setSelectedColor(id);
  };

  const onPress = () => {
    const findNum = playerOptions.find((e) => e.id == selectedOption);
    const findColor = piseList.find((e) => e.id == selectedColor);
    if (mode == "computer") {
      navigation.dispatch(
        StackActions.replace(ROUTE_NAME.PlayWithComputer, {
          numPlayers: findNum?.players,
          userColor: findColor?.label?.toLowerCase(),
        }),
      );
    } else {
      navigation.dispatch(
        StackActions.replace(ROUTE_NAME.PlayWithFriend, {
          numPlayers: findNum?.players,
          userColor: findColor?.label?.toLowerCase(),
        }),
      );
    }
  };

  // Helper for back press (touch sound + navigate)
  const handleBackPress = () => {
    userAction.setTouchSound(true); // Trigger touch sound on back
    navigation.goBack();
  };

  // Helper for start press (touch sound + stop music + navigate)
  const handleStartPress = () => {
    userAction.setTouchSound(true); // Trigger touch sound on start
    userAction.setMusicPreference(false); // Stop music for game
    userAction.setPlayGame(true);
    onPress();
  };

  return (
    <ImageBackground source={AppIcons.screenBackground} style={styles.mainView}>
      <TouchableOpacity
        onPress={handleBackPress} // Updated to use helper
        style={styles.backIcon}
      >
        <Image
          source={AppIcons.BackIcon}
          style={{
            width: 70,
            height: 50,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View>
        <Text style={styles.text}>
          Play with {mode == "computer" ? "Computer" : "Friends"}
        </Text>
        <Text style={styles.subText}>Select No. of Players</Text>
      </View>
      <View style={styles.playerListView}>
        {playerOptions.map((item) => (
          <TouchableOpacity
            onPress={() => selectedOptions(item.id)} // Already dispatches in selectedOptions
            activeOpacity={1}
            key={item.id}
            style={styles.playerItem}
          >
            <FastImage
              source={
                item.id === selectedOption
                  ? AppIcons.SelectedPlayerBtn
                  : AppIcons.PlayerBtn
              }
              resizeMode={FastImage.resizeMode.contain}
              style={styles.playerback}
            >
              <Image source={item.icon} style={styles.playerIcon} />
              <Text style={styles.label}>{item.label}</Text>
            </FastImage>
          </TouchableOpacity>
        ))}
      </View>
      <Spacer size={40} />
      {mode == "computer" && (
        <FastImage
          source={AppIcons.SelectTokenBackground}
          style={styles.selectdeTokenBack}
          resizeMode={FastImage.resizeMode.stretch}
        >
          <Text style={styles.chooseText}>Choose Color</Text>
          <View style={styles.playerListView}>
            {piseList.map((item, index) => {
              if (index == 1 && selectedOption == 1) {
                return;
              }
              if (index == 3 && selectedOption == 1) {
                return;
              }
              if (index > 2 && selectedOption == 2) {
                return;
              }
              return (
                <TouchableOpacity
                  activeOpacity={1}
                  onPress={() => selectedColors(item.id)} // Already dispatches in selectedColors
                  key={item.id}
                  style={styles.playerItem}
                >
                  <Image source={item.icon} style={styles.playerIcon1} />
                  <Text style={styles.label1}>{item.label}</Text>
                  {item.id === selectedColor ? (
                    <Image source={AppIcons.TickIcon} style={styles.tick} />
                  ) : (
                    <Image source={AppIcons.UnTickIcon} style={styles.tick} />
                  )}
                </TouchableOpacity>
              );
            })}
          </View>
        </FastImage>
      )}
      <TouchableOpacity
        activeOpacity={1}
        style={{ alignSelf: "center", marginTop: 20 }}
        onPress={handleStartPress} // Updated to use helper
      >
        <LinearGradient
          colors={[
            AppTheme.colors.linearGradient_5,
            AppTheme.colors.linearGradient_6,
          ]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.googleBtn1}
        >
          <LinearGradient
            colors={[
              AppTheme.colors.linearGradient_1,
              AppTheme.colors.linearGradient_2,
            ]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.googleBtn}
          >
            <Text style={styles.startText}>START GAME</Text>
          </LinearGradient>
        </LinearGradient>
      </TouchableOpacity>
      <View style={styles.botttomView}>
        <BannerAd
          ref={bannerRef}
          unitId={bannerAdKey}
          size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        />
      </View>
    </ImageBackground>
  );
};

export default SelectPlayersTablet;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
    justifyContent: "center",
  },
  backIcon: {
    position: "absolute",
    top: 70,
    right: 0,
  },
  text: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 45,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
    marginTop: 40,
  },
  subText: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    fontSize: 28,
    marginTop: 50,
  },
  playerListView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-around",
    marginHorizontal: 10,
  },
  playerItem: {
    marginTop: 15,
    alignItems: "center",
  },
  playerback: {
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
  },
  playerIcon: {
    width: 130,
    height: 130,
  },
  label: {
    fontSize: 24,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  selectdeTokenBack: {
    width: "95%",
    aspectRatio: Platform.OS === "web" ? 800 / 526 : undefined,
    height: Platform.OS === "web" ? undefined : "29%",
    alignSelf: "center",
    paddingTop: Platform.OS === "web" ? 10 : 20,
    justifyContent: Platform.OS === "web" ? "space-around" : "flex-start",
  },
  chooseText: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    fontSize: Platform.OS === "web" ? 22 : 25,
    marginTop: Platform.OS === "web" ? 2 : 10,
  },
  playerIcon1: {
    width: 70,
    height: 70,
    resizeMode: "contain",
  },
  label1: {
    fontSize: 19,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
  },
  tick: {
    width: 40,
    height: 40,
    resizeMode: "contain",
  },
  googleBtn: {
    width: 300,
    height: 68,
    borderRadius: 30,
    justifyContent: "center",
  },

  googleBtn1: {
    width: 300,
    height: 75,
    borderRadius: 35,
  },
  startText: {
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 35,
    color: AppTheme.colors.white,
    textAlign: "center",
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
});
